import { api } from './api'
import { throwApiError } from './apiHelpers'

function assertSuccess(body: unknown) {
  const b = body as { success?: boolean; message?: string; data?: unknown }
  if (!b?.success) {
    throw new Error(b?.message || 'Request failed')
  }
  return b.data
}

export type SupportAccessMintResult = {
  token: string
  sessionId: string
  organisationId: number
  organisationName: string
  accessMode: 'read_only' | 'full'
  expiresAt: string
  launchUrl: string | null
  policy: string
}

export async function mintOrganisationSupportAccess(
  organisationId: number | string,
  body?: { accessMode?: 'read_only' | 'full'; reason?: string },
): Promise<SupportAccessMintResult> {
  try {
    const { data } = await api.post(
      `/admin/organisations/${encodeURIComponent(String(organisationId))}/support-access`,
      body ?? {},
    )
    return assertSuccess(data) as SupportAccessMintResult
  } catch (e) {
    throwApiError(e, 'Failed to start support access')
  }
}
